<template>
  <div class="team">
    <div ref="header"><Header :bg="bg"></Header></div>
    <div class="toubu">
      <div class="text">
        专家团队为企业赋能
        <div class="bottom">
          由成都汉康赞助成立的上海感知城市数据科学研究院专家团队
        </div>
      </div>
    </div>

    <!-- <div class="title">
      专家团队
      <em></em>
    </div> -->
    <div class="box">
      <div class="son" v-for="(item, index) in list" :key="index">
        <img :src="item.src" alt="" class="img" />
        <div class="right">
          <div class="top">
            <div class="name">{{ item.name }}</div>
            <div class="zhiwei">{{ item.zhiwei }}</div>
          </div>
          <div class="bottom">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <div class="toback" ref="toback">
      <div class="toback-lianxi">
        <div class="toback-ph">
          <div class="toback-sons">
            <div class="toback-barss">
              <div class="toback-top">咨询电话</div>
              <div class="toback-bottom">133-3098-1239</div>
            </div>
            <div class="toback-barss">
              <div class="toback-top">技术支持</div>
              <div class="toback-bottom">189-8005-3442</div>
            </div>
            <div class="toback-barss">
              <div class="toback-top">售后电话</div>
              <div class="toback-bottom">400-8878-352</div>
            </div>
          </div>
        </div>
        <div class="toback-wx">
          <div class="toback-son">
            <img src="@/assets/imgs/home/gongzonghao.png" alt />
            <div class="toback-tip">(成都汉康微信)</div>
          </div>
        </div>
      </div>
      <div class="toback-up" @click="up"></div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Footer from "../../../components/Footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      list: [
        {
          name: "陈亚民",
          zhiwei: "名誉院长",
          src: require("../../../assets/imgs/guanyu/zhuanjia/1.png"),
          text: "上海交通大学安泰经管学院教授，财政部会计准则咨询专家、住建部智慧城市专家组投资专业学组组长、中国民私营经济研究会理事",
        },
        {
          name: "乐嘉锦",
          zhiwei: "院长",
          src: require("../../../assets/imgs/guanyu/zhuanjia/2.png"),
          text: "东华大学教授、校学术委员会委员、计算机科学与技术学院教授委员会主任，中国计算机学会数据库专委委员、上海市软件行业协会常务理事、上海市数据库用户协会理事长、上海计算机开放系统协会理事长",
        },
        {
          name: "金耀辉",
          zhiwei: "执行院长",
          src: require("../../../assets/imgs/guanyu/zhuanjia/3.png"),
          text: "上海交通大学教授、网络信息中心副主任，前朗讯科技贝尔实验室基础科学研究院高级研究员，教育部“新世纪优秀人才”， 中国计算机学会互联网专委常委、中国开源云计算联盟副理事长、上海市政府开放数据专家组成员",
        },
        {
          name: "朱琳",
          zhiwei: "副院长",
          src: require("../../../assets/imgs/guanyu/zhuanjia/4.png"),
          text: "华东理工大学社会与公管学院副教授，上海交通大学博士后、美国纽约州立大学政府技术研究中心访问学者",
        },
        {
          name: "李继云",
          zhiwei: "研究总监",
          src: require("../../../assets/imgs/guanyu/zhuanjia/5.png"),
          text: "博士，东华大学计算机科学与技术学院计算机应用学科教授，中国计算机学会分布式与并行计算专委会委员、中国人工智能与人工心理委员会委员，美国印第安纳大学决策研究实验室访问学者",
        },
        {
          name: "史健勇",
          zhiwei: "研究员/分析师",
          src: require("../../../assets/imgs/guanyu/zhuanjia/6.png"),
          text: "上海交通大学船建学院副教授，英国帝国理工大学博士后/访问学者，上海市规土局土地处副处长（挂职）",
        },
        {
          name: "王永坤",
          zhiwei: "研究员/构架师",
          src: require("../../../assets/imgs/guanyu/zhuanjia/7.png"),
          text: "上海交通大学网络信息中心工程师，日本东京大学博士，前日本乐天大数据研究所首席工程师、数据科学家",
        },
        {
          name: "高丰",
          zhiwei: "研究员/布道师",
          src: require("../../../assets/imgs/guanyu/zhuanjia/8.png"),
          text: "复旦大学数字与移动治理实验室客座研究员，英国南安普敦大学博士，上海开放数据创新应用大赛（SODA）项目总监，开放数据中国联合创始人",
        },
        {
          name: "肖卫兵",
          zhiwei: "研究员/法律专员",
          src: require("../../../assets/imgs/guanyu/zhuanjia/9.png"),
          text: "上海政法学院教授，澳大利亚塔斯马尼亚大学法学博士，兼职研究员。现任经济法教研室主任。上海市浦江人才计划和教育部留学归国人员科研启动基金获得者。主要研究领域为政府信息公开、数据开放、社会信用法制。",
        },
      ],
      timer: null,
      arr: [],
      bg: null,
    };
  },
  methods: {
    up() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let sudu = 40;
      if (top >= 0 && top < 1000) {
        sudu = 40;
      } else if (top >= 1000 && top < 2000) {
        sudu = 60;
      } else if (top >= 2000 && top < 3000) {
        sudu = 100;
      } else if (top >= 3000 && top < 4000) {
        sudu = 140;
      } else {
        sudu = 200;
      }
      this.timer = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            sudu;

        if (top <= 0) {
          clearInterval(this.timer);
        }
      }, 10);

      // document.body.scrollTop = 0;
    },
    scroll() {
      let scroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.arr.push(scroll);
      //console.log("scroll :>> ", scroll);
      if (this.arr.length > 2) {
        let a = [this.arr[this.arr.length - 1]];
        let b = [this.arr[this.arr.length - 2]];

        if (a - b >= 0) {
          // console.log("往下滑");

          this.$refs.header.style.position = "absolute";
          this.$refs.header.style.top = "0";
          this.$refs.header.style.left = "0";
          this.$refs.header.style.zIndex = "100";

          if (scroll >= 470) {
            this.show = true;
          } else {
            this.show = false;
          }
        } else {
          // console.log("往上滑");
          if (scroll > 300) {
            this.$refs.header.style.position = "fixed";
            this.$refs.header.style.top = "0";
            this.$refs.header.style.left = "0";
            this.$refs.header.style.zIndex = "100";
            this.bg = "black";
          }
        }
        if (scroll > 120) {
          this.$refs.toback.style.opacity = "1";
        } else {
          this.$refs.toback.style.opacity = "0";
        }
        if (scroll <= 280) {
          this.$refs.header.style.position = "absolute";
          this.$refs.header.style.top = "0";
          this.$refs.header.style.left = "0";
          this.$refs.header.style.zIndex = "100";
        }
      }
    },
  },
  mounted() {
    document.body.scrollTop = 0;

    window.addEventListener("scroll", this.scroll, true);
  },
  beforeDestroy() {
    // this.time=null
    window.removeEventListener("scroll", this.scroll, true);
  },
};
</script>

<style lang="scss" scoped>
.team {
  width: 1920px;
  height: 100%;
  background-color: #fff;
  margin: 0 auto;

  .toubu {
    width: 1920px;
    height: 500px;
    background-image: url("../../../assets/imgs/guanyu/tuanduibg.png");
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    .text {
      // width: 462px;
      position: absolute;
      top: 180px;
      left: 343px;
      font-size: 60px;
      font-family: Alibaba PuHuiTi;
      font-weight: 700;
      line-height: 84px;
      color: #ffffff;
      .bottom {
        font-size: 20px;
        font-family: Alibaba PuHuiTi Xi;
        font-weight: normal;
        line-height: 22px;
        color: #ffffff;
        margin-top: 8px;
      }
    }
  }
  .title {
    text-indent: 20px;
    font-size: 20px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    position: relative;
    margin-left: 260px;
    margin-top: 100px;
    em {
      width: 6px;
      height: 24px;
      background-color: rgba(68, 112, 255, 1);
      position: absolute;
      left: 2px;
      top: 2px;
    }
  }
  .box {
    width: 1920px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 260px;
    margin-bottom: 40px;
    padding-top: 60px;

    .son {
      width: 678px;
      height: 224px;
      display: flex;
      justify-content: space-between;
      background: rgba(246, 246, 246, 1);
      // border: 1px solid rgba(68, 112, 255, 0.5019607843137255);
      //margin-top: 80px;
      margin-bottom: 20px;
      padding: 37px 36px 0 36px;
      .img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
      }
      .right {
        width: 432px;
        height: 100%;

        .top {
          height: 70px;

          border-bottom: 1px solid rgba(235, 235, 235, 1);
          display: flex;
          align-items: center;
          position: relative;
          bottom: 18px;
          .name {
            font-size: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;

            color: #333333;
          }
          .zhiwei {
            font-size: 16px;
            font-family: Alibaba PuHuiTi Xi !important;
            font-weight: 400;
            margin-left: 25px;
            color: #888888;
          }
        }
        .bottom {
          font-size: 16px;
          font-family: Alibaba PuHuiTi Xi !important;
          font-weight: 300;
          line-height: 24px;
          color: #888888;
        }
      }
    }
    .son:hover .top {
      border-bottom: 1px solid rgba(51, 51, 51, 1);
    }
    .son:hover {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
  }
}
</style>
